import _ from 'underscore';
import rivets from 'rivets';
import BaseView from '../../core/baseView';
import Fttc1ViewModel from './fttc1ViewModel';
import { get as t } from '../../../home24/core/translation';
import * as lightbox from '../../../home24/helpers/lightbox';
import * as registry from '../../../home24/core/registry';
export default BaseView.extend({
  initialize: function() {
    this.viewModel = new Fttc1ViewModel();

    this.viewModel.get('col1').items = _.values(this.model.attributes);

    this.setupRivetsBindings();
  },

  rivetsEventHandlers: [
    'mainTopicChange',
    'subTopicChange',
    'questionClicked',
    'submitReclamationRequest',
    'submitContactRequest',
    'showFttcCallPopup'
  ],

  setupRivetsBindings: function() {
    this.binding = rivets.bind(this.el, {
      viewModel: this.viewModel,
      eventHandlers: this
    });
  },

  mainTopicChange: function(event, binding) {
    if (binding.item) {
      var col2;

      _.each(this.viewModel.get('col1').items, function(item) {
        item.selected = false;
      });

      _.each(this.viewModel.get('col2').items, function(item) {
        item.selected = false;
      });

      binding.item.selected = true;

      col2 = this.viewModel.get('col2');

      col2.show = true;
      col2.name = binding.item.name;
      col2.items = _.values(binding.item.children);

      this.viewModel.get('col3').show = false;
    }
  },

  subTopicChange: function(event, binding) {
    if (binding.item) {
      _.each(this.viewModel.get('col2').items, function(item) {
        item.selected = false;
      });

      binding.item.selected = true;

      this.viewModel.get('col3').items = _.values(binding.item.children);

      _.each(this.viewModel.get('col3').items, function(item) {
        var dataVariantUrl;

        if (item.reclamation) {
          switch (item.reclamation) {
            case 'variant1':
              dataVariantUrl = registry.get('fttcFormUrls').dataVariant1Url;
              break;
            case 'variant2':
              dataVariantUrl = registry.get('fttcFormUrls').dataVariant2Url;
              break;
            case 'variant3':
              dataVariantUrl = registry.get('fttcFormUrls').dataVariant3Url;
              break;
          }

          item.dataVariantUrl = dataVariantUrl;
        }
      });

      // if we have one only one item in 3rd row - open it
      if (this.viewModel.get('col3').items.length === 1) {
        this.viewModel.get('col3').items[0].show = true;
      }

      this.viewModel.get('col3').show = true;

      this.$el.find('.fttc-area .fttc-block1').slideUp(0);
    }
  },

  questionClicked: function(event, binding) {
    if (binding.item) {
      // Visibility status of the clicked item
      let itemVisibility = binding.item.show;

      // Hide all the items in the list
      _.each(this.viewModel.get('col3').items, function(item) {
        item.show = false;
      });

      // Toggle visibility of the clicked item
      binding.item.show = !itemVisibility;
    }
  },

  submitReclamationRequest: function(event, binding) {
    this.viewModel.set('formAction', binding.item.dataVariantUrl);
    this.submitForm();
  },

  submitContactRequest: function() {
    this.viewModel.set('formAction', registry.get('fttcFormUrls').contactUrl);
    this.submitForm();
  },

  submitForm: function() {
    var $form = this.$('#helparea_form');

    $form.submit();
  },

  showFttcCallPopup: function() {
    lightbox
      .setConfig({
        className: 'fttc1-call-lightbox'
      })
      .open(t('ui.fttc.call_button.hover.label'));
  },

  setFttcById: function(id) {
    var cols = this.model.returnTreeColsById(id);

    this.mainTopicChange(
      {},
      {
        item: cols.n1
      }
    );

    this.subTopicChange(
      {},
      {
        item: cols.n2
      }
    );

    this.questionClicked(
      {},
      {
        item: cols.n3
      }
    );
  }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/pages/fttc1/fttc1View.js
 **/